import { render, staticRenderFns } from "./MailingLists.vue?vue&type=template&id=293cd7b8&"
import script from "./MailingLists.vue?vue&type=script&lang=ts&"
export * from "./MailingLists.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports